<script lang="ts" setup>

</script>

<template>
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.608398" width="16" height="16" rx="8" fill="#ED0A34"/>
    <path d="M12.45 6.40772C12.3455 6.01499 12.0365 5.70517 11.6433 5.59899C10.9324 5.40845 8.08002 5.40845 8.08002 5.40845C8.08002 5.40845 5.22911 5.40845 4.51675 5.59899C4.12502 5.70372 3.81599 6.01354 3.71008 6.40772C3.52002 7.12045 3.52002 8.60845 3.52002 8.60845C3.52002 8.60845 3.52002 10.0964 3.71008 10.8092C3.81454 11.2019 4.12357 11.5117 4.51675 11.6179C5.22911 11.8084 8.08002 11.8084 8.08002 11.8084C8.08002 11.8084 10.9324 11.8084 11.6433 11.6179C12.035 11.5132 12.344 11.2034 12.45 10.8092C12.64 10.0964 12.64 8.60845 12.64 8.60845C12.64 8.60845 12.64 7.12045 12.45 6.40772Z" fill="white"/>
    <path d="M7.16889 9.98008L9.53812 8.60845L7.16889 7.23681V9.98008Z" fill="#ED0A34"/>
  </svg>
</template>